import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { ImageServerInfoModel, ServerInfoModel } from '@models/server-info-model';
import { HttpService } from './http.service';

@Injectable({
	providedIn: 'root'
})
export class ServerInfoService {

	constructor(
		private httpService: HttpService,
	) {
	}

	public async getServerInfo(): Promise<ServerInfoModel | null> {
		const endpoint = `${environment.dataUrl}/serverinfo`;
		const serverinfo = await this.getNetworkFirst<ServerInfoModel>(endpoint);
		return serverinfo;
	}

	public async getImageServerInfo(): Promise<ImageServerInfoModel | null> {
		const endpoint = `${environment.imageUrl}/hostinfo.ashx`;
		const serverinfo = await this.getNetworkFirst<ImageServerInfoModel>(endpoint, this.getOptionsForImageServerRequest());
		return serverinfo;
	}

	public async getImageCdnServerInfo(): Promise<ImageServerInfoModel | null> {
		const endpoint = `${environment.imageCDNUrl}/hostinfo.ashx`;
		const serverinfo = await this.getNetworkFirst<ImageServerInfoModel>(endpoint, this.getOptionsForImageServerRequest());
		return serverinfo;
	}

	public async getMiscImageCount(eCommerNo: string | null | undefined): Promise<number | null> {
		const imageUrl = environment.imageCDNUrl;

		try {
			var x = this.getNetworkFirst<number>(`${imageUrl}/product/${eCommerNo}/List`, this.getOptionsForImageServerRequest());
			return x;
		}
		catch (error) {
			console.error(error)
		}
		return null
	}

	private getOptionsForImageServerRequest(): any {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "text/plain");
		httpHeaders.set("Accept", "*/*");
		httpHeaders.delete("Origin");

		const options = { headers: httpHeaders, withCredentials: false };
		return options;
	}

	public async getNetworkFirst<T>(url: string, options: any = undefined): Promise<T | null> {
		let result: T | null = null;

		try {
			result = await this.httpService.getDataWithOfflineCheck<T>(url, options);

			return result;
		}
		catch (e) {
			throw e;
		}
	}

}
